import React from "react";
import { CheckLabel } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { LinkToReportTab } from "../../common";
import FileCard from "./FileCard";
import styles from "./fileInfoStyles.module.scss";
const FileInfo = ({ releaseStatus, fileInfo, scanLevel, isLevelCustomized, isReproducibilityCheck, isDiffCheck, size, scanTimestamp, scanDuration, onClick, }) => {
    let to = REPORT_PAGES_ROUTES.ISSUES_ROUTE;
    if (isReproducibilityCheck) {
        to = REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE;
    }
    else if (isDiffCheck) {
        to = REPORT_PAGES_ROUTES.VERSION_DIFF;
    }
    if (size === "large") {
        return (React.createElement(FileCard, { releaseStatus: releaseStatus, fileInfo: fileInfo, scanLevel: scanLevel, isLevelCustomized: isLevelCustomized, isReproducibilityCheck: isReproducibilityCheck, isDiffCheck: isDiffCheck, scanTimestamp: scanTimestamp, scanDuration: scanDuration, onClick: onClick }));
    }
    return (React.createElement("div", { className: styles["file-summary-small"] },
        React.createElement(LinkToReportTab, { underline: "none", id: "pass-fail-icon", to: to, "aria-label": "CI/CD status", onClick: onClick },
            React.createElement(CheckLabel, { scanLevel: scanLevel, status: releaseStatus, isLevelCustomized: isLevelCustomized, isDiffCheck: isDiffCheck, isReproducibilityCheck: isReproducibilityCheck, className: styles["status-icon-small"] }))));
};
export default FileInfo;
//# sourceMappingURL=FileInfo.js.map